const getBaseUrl = () => {
    switch (process.env.NODE_ENV) {
        case 'production':
            return process.env.REACT_APP_API_URL || 'https://api.yourdomain.com';
        case 'staging':
            return process.env.REACT_APP_API_URL || 'https://staging-api.yourdomain.com';
        default:
            return process.env.REACT_APP_API_URL || 'http://estate.test/api';
    }
};

export const API_CONFIG = {
    BASE_URL: getBaseUrl(),
    TIMEOUT: 30000, // Optional: add other API configs
};